import { removeEndingSlashes } from '~/plugins/helper'
export * from 'enums/./seo-shared'

export const GROUP_TYPE = {
  STATIC: 'Static'
}

export const NO_DIRECTIVE = 'Nodirectives'

export const TEMPLATE_PARAM = {
  [GROUP_TYPE.STATIC]: {
    META_TITLE: 'PAGE_NAME',
    META_DESCRIPTION: 'PAGE_NAME'
  }
}

export const TEMPLATE_PARAMS_LIST = Object.values(TEMPLATE_PARAM)

export const META_TITLE_PARAMS_REGEX = new RegExp(
  TEMPLATE_PARAMS_LIST.map(({ META_TITLE }) => META_TITLE).join('|'),
  'g'
)

export const META_DESCRIPTION_PARAMS_REGEX = new RegExp(
  TEMPLATE_PARAMS_LIST.map(({ META_DESCRIPTION }) => META_DESCRIPTION).join(
    '|'
  ),
  'g'
)

/** Needed to request SEO settings for error page **/
export const STATIC_PAGE = {
  ERROR: 'error/',
  HOMEPAGE: '/'
}

export const GROUP_TYPES_WITHOUT_ENDING_SLASH_IN_SLUG = []

export function checkIfGroupTypeWithoutEndingSlash(groupType) {
  return GROUP_TYPES_WITHOUT_ENDING_SLASH_IN_SLUG.includes(groupType)
}

export function handleEndingSlash(slug, possibleGroupTypes) {
  const isSlugWithoutEndingSlash = possibleGroupTypes.every(groupType =>
    checkIfGroupTypeWithoutEndingSlash(groupType)
  )

  return `${removeEndingSlashes(slug)}${isSlugWithoutEndingSlash ? '' : '/'}`
}
